'use client';

import { useState } from 'react';
import { Save, Clock } from 'lucide-react';

export interface SessionNotesProps {
  sessionId: string;
  clientName: string;
  /** IANA timezone for display (e.g. 'Australia/Perth'). Defaults to 'Australia/Sydney'. */
  timezone?: string;
}

export function SessionNotes({ sessionId: _sessionId, clientName, timezone }: SessionNotesProps) {
  const [notes, setNotes] = useState('');
  const [savedAt, setSavedAt] = useState<string | null>(null);

  const handleSave = () => {
    setSavedAt(
      new Date().toLocaleTimeString('en-AU', { timeZone: timezone ?? 'Australia/Sydney' }),
    );
  };

  return (
    <div className="flex h-full flex-col border-l border-slate-200 bg-white">
      <div className="border-b border-slate-200 p-4">
        <h3 className="font-heading text-card-title text-text-heading">Session Notes</h3>
        <p className="mt-1 font-body text-caption text-text-muted">{clientName}</p>
      </div>
      <div className="flex-1 p-4">
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Type clinical notes here..."
          className="h-full w-full resize-none rounded-xl border border-slate-300 p-3 font-body text-body-sm text-text-heading transition-interactive duration-200 placeholder:text-text-subtle focus:border-statura-green focus:outline-none focus:ring-[3px] focus:ring-statura-green/20"
        />
      </div>
      <div className="flex items-center justify-between border-t border-slate-200 p-4">
        {savedAt && (
          <span className="flex items-center gap-1 font-body text-caption text-text-subtle">
            <Clock className="h-3 w-3" /> Saved {savedAt}
          </span>
        )}
        <button
          onClick={handleSave}
          className="ml-auto flex items-center gap-2 rounded-xl bg-statura-ink-dark px-4 py-2 font-body text-body-sm font-semibold text-white transition-interactive duration-200 hover:bg-statura-ink"
        >
          <Save className="h-4 w-4" /> Save Notes
        </button>
      </div>
    </div>
  );
}
